import { MOBILE_SMALL_SCREEN as n } from "./screens.mjs";
import { styled as a, css as o } from "./styled2.mjs";
import { Box as c, svgIconClasses as s } from "@mui/material";
import { Typography as l } from "./index59.mjs";
const i = (e) => {
  switch (e) {
    case "primary":
      return o`
				background-color: ${({ theme: t }) => t.palette.primary.main08};
				border-color: ${({ theme: t }) => t.palette.primary.main30};
			`;
    case "destructive":
      return o`
				background-color: ${({ theme: t }) => t.palette.error.main08};
				border-color: ${({ theme: t }) => t.palette.error.main30};
			`;
    case "info":
      return o`
				background-color: ${({ theme: t }) => t.palette.info.main08};
				border-color: ${({ theme: t }) => t.palette.info.main30};
			`;
    case "warning":
      return o`
				background-color: ${({ theme: t }) => t.palette.warning.main08};
				border-color: ${({ theme: t }) => t.palette.warning.main30};
			`;
    case "success":
      return o`
				background-color: ${({ theme: t }) => t.palette.success.main08};
				border-color: ${({ theme: t }) => t.palette.success.main30};
			`;
    case "default":
    default:
      return o`
				background-color: ${({ theme: t }) => t.palette.grey[50]};
				border-color: ${({ theme: t }) => t.palette.other.outlinedBorder};
			`;
  }
}, p = (e, t) => {
  if (e === "solid")
    switch (t) {
      case "primary":
        return o`
					background: ${({ theme: r }) => r.palette.primary.main};
					color: ${({ theme: r }) => r.palette.primary.contrast};
				`;
      case "destructive":
        return o`
					background: ${({ theme: r }) => r.palette.error.main};
					color: ${({ theme: r }) => r.palette.error.contrast};
				`;
      case "info":
        return o`
					background: ${({ theme: r }) => r.palette.info.main};
					color: ${({ theme: r }) => r.palette.info.contrast};
				`;
      case "warning":
        return o`
					background: ${({ theme: r }) => r.palette.warning.main};
					color: ${({ theme: r }) => r.palette.warning.contrast};
				`;
      case "success":
        return o`
					background: ${({ theme: r }) => r.palette.success.main};
					color: ${({ theme: r }) => r.palette.success.contrast};
				`;
      case "default":
      default:
        return o`
					background: ${({ theme: r }) => r.palette.secondary.main};
					color: ${({ theme: r }) => r.palette.secondary.contrast};
				`;
    }
  if (e === "outlined")
    return o`
			border-style: solid;
			border-width: 1px;
		`;
}, d = (e, t) => {
  if (e === "solid")
    return o`
			color: ${({ theme: r }) => r.palette.primary.contrast};
		`;
  switch (t) {
    case "primary":
      return o`
				color: ${({ theme: r }) => r.palette.primary.light};
			`;
    case "destructive":
      return o`
				color: ${({ theme: r }) => r.palette.error.light};
			`;
    case "info":
      return o`
				color: ${({ theme: r }) => r.palette.info.light};
			`;
    case "warning":
      return o`
				color: ${({ theme: r }) => r.palette.warning.light};
			`;
    case "success":
      return o`
				color: ${({ theme: r }) => r.palette.success.light};
			`;
    case "default":
    default:
      return o`
				color: ${({ theme: r }) => r.palette.secondary.light};
			`;
  }
}, u = (e, t) => {
  switch (t) {
    case "primary":
      return o`
				color: ${({ theme: r }) => e === "solid" ? r.palette.primary.contrastText : r.palette.primary.dark};
			`;
    case "destructive":
      return o`
				color: ${({ theme: r }) => e === "solid" ? r.palette.error.contrastText : r.palette.error.dark};
			`;
    case "info":
      return o`
				color: ${({ theme: r }) => e === "solid" ? r.palette.info.contrastText : r.palette.info.dark};
			`;
    case "warning":
      return o`
				color: ${({ theme: r }) => e === "solid" ? r.palette.warning.contrastText : r.palette.warning.dark};
			`;
    case "success":
      return o`
				color: ${({ theme: r }) => e === "solid" ? r.palette.success.contrastText : r.palette.success.dark};
			`;
    case "default":
    default:
      return o`
				color: ${({ theme: r }) => e === "solid" ? r.palette.secondary.contrastText : r.palette.secondary.dark};
			`;
  }
}, y = a(c)`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	${({ theme: e }) => e.breakpoints.down(n)} {
		flex-direction: column;
	}
	gap: ${({ theme: e }) => e.spacing(2)};
	padding-inline: ${({ theme: e }) => e.spacing(2)};
	padding-block: ${({ theme: e }) => e.spacing(2)};
	border-radius: ${({ theme: e }) => e.spacing(1)};

	${({ $state: e }) => i(e)};
	${({ $variant: e, $state: t }) => p(e, t)};
`, b = a(c)`
	display: flex;
	align-items: center;

	&:empty {
		display: none;
	}

	.${s.root} {
		${({ $variant: e, $state: t }) => d(e, t)};
	}
`, x = a(l.TextMd.SemiBold)`
	padding-top: ${({ theme: e }) => e.spacing(0.3)};
	${({ $state: e, $variant: t }) => u(t, e)};
`, k = a(l.TextSm.Regular)`
	color: ${({ theme: e, $variant: t }) => t === "solid" ? e.palette.primary.contrast : e.palette.text.body};

	&:empty {
		display: none;
	}
`, w = a(c)`
	display: flex;
	column-gap: ${({ theme: e }) => e.spacing(1)};
	row-gap: ${({ theme: e }) => e.spacing(2)};
	${({ theme: e }) => e.breakpoints.up(n)} {
		align-items: center;
		> button {
			min-width: max-content;
		}
	}
	${({ theme: e }) => e.breakpoints.down(n)} {
		flex-direction: column;
	}
`;
export {
  w as AlertCardActionWrapper,
  k as AlertCardChildren,
  b as AlertCardIconWrapper,
  x as AlertCardTitle,
  y as StyledAlertCard
};
//# sourceMappingURL=styles.mjs.map
